'use client'

import { useTranslations } from 'next-intl'

import { WarningFilledIcon } from '@/ui/icons/WarningFilledIcon'

import S from '../../../moderation/ClubModeration.module.scss'

type BlockedClubBannerProps = {
  onContactSupport: () => void
  hasActiveSupportTicket?: boolean
}

export function BlockedClubBanner({
  onContactSupport,
  hasActiveSupportTicket = false
}: BlockedClubBannerProps) {
  const t = useTranslations('club.blockedProfile')

  return (
    <div className={S.rejectBanner}>
      <div className={S.rejectBannerContent}>
        <span className={S.rejectBannerIcon} aria-hidden>
          <WarningFilledIcon color="var(--color-accent)" />
        </span>
        <div className={S.rejectBannerText}>
          <h2 className={S.rejectBannerTitle}>{t('blockedBanner.title')}</h2>
          <p className={S.rejectBannerDesc}>{t('blockedBanner.desc')}</p>
        </div>
      </div>
      <button
        type="button"
        className={S.rejectBannerButton}
        onClick={hasActiveSupportTicket ? undefined : onContactSupport}
        disabled={hasActiveSupportTicket}
        title={hasActiveSupportTicket ? 'Ticket is pending review' : undefined}
      >
        {hasActiveSupportTicket
          ? t('blockedBanner.pending')
          : t('blockedBanner.contactSupport')}
      </button>
    </div>
  )
}
